import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  {
    prefix: "CREATE_OUVIDORIA_",
  }
);

export interface CreateOuvidoriaState extends IState {}

const INITIAL_STATE: CreateOuvidoriaState = {
  data: {},
  loading: false,
  error: null,
};

const request = (state: CreateOuvidoriaState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CreateOuvidoriaState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: CreateOuvidoriaState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createOuvidoria = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreateOuvidoriaTypes = Types;
export const CreateOuvidoriaActions = Creators;
